import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String,
    frame: String
  }

  connect() {
    this.element.style.cursor = 'pointer';
    let table = this.element.closest('table');
    if (!table) { return; }

    table.classList.add('table-hover');
  }

  linkTo(event) {
    if (event.target.closest('a')) { return; }
    let frame = this.frameValue;
    if (!frame) { frame = 'modal'; }

    event.preventDefault();
    const url = new URL(this.urlValue, window.location.origin);

    Turbo.visit(url.toString(), { frame: frame })
  }
}